'use client';

import * as Dropdown from '@radix-ui/react-dropdown-menu';
import { useTranslations } from 'next-intl';
import { ComponentPropsWithRef, useState } from 'react';
import { cn } from '@/shared/lib/cn';
import { Button } from '@/shared/ui/button';
import { Icon } from '@/shared/ui/icon';
import { Layout } from '@/shared/ui/layout';

type Props = {
    count?: number;
    contentAlign?: 'start' | 'center' | 'end';
} & ComponentPropsWithRef<typeof Button>;
export const MenuTrigger = ({ count = 0, contentAlign = 'start', children, className, ...props }: Props) => {
    const t = useTranslations();
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Dropdown.Root open={isOpen} onOpenChange={setIsOpen} modal={false}>
            <Dropdown.Trigger asChild>
                <Layout
                    element={Button}
                    variant="ghost"
                    aria-label={t('NAVBAR.MENU_BUTTON')}
                    className={cn('menu__button', className)}
                    data-testid="menu-button"
                    {...props}
                >
                    {isOpen ? (
                        <Icon name="close" width={24} height={24} />
                    ) : (
                        <Icon name="menu" width={30} height={30} />
                    )}
                    {count > 0 && (
                        <div className="menu__badge">
                            <span className="menu__badge-text">{count}</span>
                        </div>
                    )}
                </Layout>
            </Dropdown.Trigger>
            <Dropdown.Portal>
                <Dropdown.Content
                    align={contentAlign}
                    sideOffset={17}
                    alignOffset={-6}
                    className="menu__dropdown-content"
                >
                    {children}
                </Dropdown.Content>
            </Dropdown.Portal>
        </Dropdown.Root>
    );
};
